import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class HttpService {
  constructor(public http: HttpClient) {
  }

  post(apiRoute: string, body: any, headers: any) {
    return this.http.post(`${apiRoute}`, body, { headers: headers });
  }

  get(apiRoute: string, responseType: string) {
    return this.http.get(`${apiRoute}`, { headers: this.getHttpHeaders(), responseType: responseType as 'text' });
  }

  put(apiRoute: string, body: any) {
    return this.http.put(`${apiRoute}`, body, { headers: this.getHttpHeaders()});
  }
  getHttpHeaders(): HttpHeaders {
    return new HttpHeaders().set("key", "value");
  }
}
